/**
 * The Foundation's legal name. A proper noun, so it is never a catalog value:
 * it renders under `translate="no"` and reaches translated sentences as the
 * `{{org}}` placeholder (#2109). `TRF` is the glossary term; this is the
 * expansion the public chrome prints.
 */
export const ORG_NAME = 'Tyler Robinson Foundation';
